import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/motion";

const PaymentCancel = () => {
  useSeo({ title: "Paiement annulé", noindex: true });
  return (
  <main data-testid="payment-cancel-page" className="">
    <div className="mx-auto flex max-w-2xl flex-col items-center px-6 py-28 text-center lg:px-10">
      <Reveal>
        <XCircle className="mx-auto h-16 w-16 text-ochre" />
        <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-bark sm:text-5xl">Paiement annulé</h1>
        <p className="mt-4 max-w-md text-bark/60">
          Aucun montant n'a été débité. Votre commande reste en attente — vous pouvez réessayer quand vous le souhaitez.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/boutique" data-testid="payment-cancel-shop-link" className="flex h-14 items-center rounded-full bg-terracotta px-8 text-sm font-bold uppercase tracking-[0.15em] text-sand transition-colors hover:bg-terracotta-dark">
            Retour à la boutique
          </Link>
          <Link to="/suivi" data-testid="payment-cancel-tracking-link" className="flex h-14 items-center rounded-full border border-bark/20 px-8 text-sm font-bold uppercase tracking-[0.15em] text-bark transition-colors hover:border-terracotta hover:text-terracotta">
            Suivi de commande
          </Link>
        </div>
      </Reveal>
    </div>
  </main>
  );
};

export default PaymentCancel;
